import { render, staticRenderFns } from "./LogoutItem.vue?vue&type=template&id=1f153b03&scoped=true&"
var script = {}
import style0 from "./LogoutItem.vue?vue&type=style&index=0&id=1f153b03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f153b03",
  null
  
)

export default component.exports